import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {unsplashStore} from '@components/board-appearance/unsplash/unsplash-store'
import {TwSkinsContainer} from './containers'
import {UnsplashSkinsButton} from './unsplash-skins-button'
import {UnsplashSkinItem} from './unsplash-skins-item'

export const UnsplashSkins = observer(
  ({reachedLimit}: {reachedLimit?: boolean}) => {
    const showButton = !reachedLimit
    return (
      <TwSkinsContainer>
        {unsplashStore.results?.map(i => (
          <UnsplashSkinItem key={i.id} item={i} />
        ))}

        {showButton && <UnsplashSkinsButton />}
      </TwSkinsContainer>
    )
  }
)
